<app-modal-template title="Delete Tenant Confirmation" [disabled]="isDeleting">
    <div class="modal-body-content mb-3">
      <div class="loadingDiv" *ngIf="isDeleting">
        <div class="loader"></div>
      </div>
      <div>
        <span>Are you sure you want to delete tenant?</span>
      </div>
      <br>
      <div class="d-flex mb-3">
        <div class="flex-fill">
          <div class="font-weight-bold">Tenant Name</div>
          <div>{{tenantName}}</div>
        </div>     
      </div>
    </div>
    <div class="modal-footer-content">
      <div class="d-flex">
        <button type="submit" class="btn btn-primary" (click)="Yes();">Yes</button>
        <button mat-button  class="btn btn-secondary ml-auto" (click)="No();" >Cancel</button>
       </div>
    </div>
  </app-modal-template>